import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './dev.css';
import './App.css'
import './reactcc.css';
//import 'typeface-roboto';
import 'segoe-fonts';
import 'typeface-droid-sans';



ReactDOM.render( <App />, document.getElementById( 'root' ) );